__turbopack_context__.v({
  "tag": "EventTag-module-scss-module__tRAWFW__tag",
});
